var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExternalLink = function SvgExternalLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.941 16.235a1.53 1.53 0 1 1 3.059 0v9.177A4.59 4.59 0 0 1 21.412 30H4.588A4.59 4.59 0 0 1 0 25.412V8.588A4.59 4.59 0 0 1 4.588 4h9.176a1.53 1.53 0 0 1 0 3.059H4.588a1.53 1.53 0 0 0-1.53 1.53v16.823a1.53 1.53 0 0 0 1.53 1.53h16.823a1.53 1.53 0 0 0 1.53-1.53z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.736 3.09h-5.512a1.537 1.537 0 1 1 0-3.074h9.018a1.536 1.536 0 0 1 1.743 1.738v9.022a1.537 1.537 0 0 1-3.075 0V5.263L12.625 19.55a1.537 1.537 0 0 1-2.175-2.173z"
  })));
};
export default SvgExternalLink;